import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import AttachmentTab from '../attachment/AttachmentTab';

export default function UserFiles({ userId }) {
  const userFiles = useSelector((state) => state.users.userFiles);

  const attachments = useMemo(() => {
    const {
      [userId]: ourFiles = [],
    } = userFiles;
    return {
      instantiatedFiles: ourFiles,
      locationMap: {},
    };
  }, [userFiles, userId]);

  return <AttachmentTab attachments={attachments} />;
}

UserFiles.propTypes = {
  userId: PropTypes.string,
};

UserFiles.defaultProps = {
  userId: undefined,
};
